<template>
  <div class="card">
    <div v-if="!!this.$slots['header']" class="card-header">
      <div class="d-flex justify-content-between">
        <slot name="header" />
        <div v-if="closable">
          <button
            class="btn-xs btn btn-link"
            type="button"
            data-toggle="collapse"
            aria-expanded="false"
            :data-target="`#${closeTriggerId}`"
            :aria-controls="closeTriggerId"
            @click="isCollapsed = !isCollapsed"
          >
            <i :class="`fa fa-${isCollapsed ? 'minus' : 'plus'}-square-o`"></i>
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="!!this.$slots['body']"
      :id="closeTriggerId"
      :class="getComputedCssClasses()"
      class="card-body"
    >
      <slot name="body" />
    </div>
    <div v-if="!!this.$slots['footer']" class="card-footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import uniqid from "uniqid";

export default {
  props: {
    closeTriggerId: {
      type: String,
      default: () => uniqid("card-close-trigger-")
    },
    normalizeCardBody: {
      type: Boolean,
      default: false
    },
    closable: {
      type: Boolean,
      default: false
    },
    startClosed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isCollapsed: this.startClosed
    };
  },
  methods: {
    getComputedCssClasses() {
      return [
        { "m-0 p-0": this.normalizeCardBody },
        { collapse: this.closable },
        { show: !this.startClosed }
      ];
    }
  }
};
</script>
